<template>
  <div>
    <v-flex xs12 v-if="showReloadMessage">
      <form-alert-full></form-alert-full>
    </v-flex>
    <v-toolbar fixed app>
      <div class="box-menu">
        <div class="box-menu-items">
          <v-toolbar-title v-if="displayPageTitle" v-html="pageName" />
          <!-- Hidden fields para automatização -->
          <input
            type="hidden"
            id="corretor_CNPJ"
            :value="me.company.document"
          />
          <input
            type="hidden"
            id="corretor_Segmento"
            :value="me.company.segmento"
          />
          <!-- Utilizando dessa tag p com a classe padrão para manter os itens a baixo no canto direito-->
          <p class="align-right greetings"></p>

          <!-- Nova Apólice -->
          <router-link
            class="menu-right menu-font-item select"
            v-if="$route.name === 'Portal do Tomador'"
            :to="{
              path: `/home`,
            }"
          >
            Nova Apólice
          </router-link>
          <router-link
            class="menu-right menu-font-item"
            v-else
            :to="{
              path: `/home`,
            }"
          >
            Nova Apólice
          </router-link>

          <!-- Apólice -->
          <router-link
            class="menu-right menu-font-item select"
            v-if="
              $route.name === 'Apólices' ||
              $route.name === 'Detalhes da Proposta'
            "
            :to="{
              path: `/apolices-tomador/${formatCNPJAndCPFNoMask(
                me.company.document
              )}`,
            }"
          >
            Apólice
          </router-link>
          <router-link
            class="menu-right menu-font-item"
            v-else
            :to="{
              path: `/apolices-tomador/${formatCNPJAndCPFNoMask(
                me.company.document
              )}`,
            }"
          >
            Apólice
          </router-link>
        </div>
        <div class="box-menu-perfil">
          <p class="perfil">
            <span>{{ me.company.razao_social }}</span>
            <small>{{ me.company.email }}</small>
          </p>
          <p class="button-logout">
            <router-link @click="logout" :to="{ path: '/' }">
              <icon-logout></icon-logout>
            </router-link>
          </p>
        </div>
      </div>
    </v-toolbar>
  </div>
</template>

<script lang="js">
import axios from "axios";
import { mapActions } from "vuex";
import { formatCNPJAndCPFNoMask } from "@/libs/utils";

export default {
  name: "JNSMenu",
  data() {
    return {
      mini: true,
      fullDrawer: true,
      reloadModal: false,
      axios,
      notificationsMenu: false,
      notificationsInterval: false,
      checkVersionInterval: false,
      COMMIT_HASH: COMMIT_HASH,
      showReloadMessage: false,
      showDrawer: false,
      formatCNPJAndCPFNoMask,
    };
  },
  computed: {
    displayPageTitle() {
      return !this.$route.meta.formPage || true;
    },

    store() {
      return this.$store;
    },

    me() {
      var meJson = JSON.parse(localStorage.getItem("me"));
      return meJson;
    },

    pageName() {
      return this.$store.state.main.pageName;
    },

    route() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions(),

    redirect(item) {
      if (item.isMenuIcon) this.setMini(!this.mini);
      if (item.title == "Logout") this.logout();
      else if (!item.subItems) {
        this.$router.push(item.path);
      }

      if (!this.mini) this.setMini(true);
    },

    logout() {
      this.$router.push({ name: "ConnectionGuard" });
      delete this.axios.defaults.headers.common["Authorization"];
    },

    setMini(value) {
      this.mini = value;
      this.$forceUpdate();
    },
  },
  mounted() {
    document.title = this.$route.name + " - JNS ";
    this.$store.commit("SET_PAGENAME", this.$route.name);
    this.init();
  },
  destroyed() {
    clearInterval(this.notificationsInterval);
    clearInterval(this.checkVersionInterval);
  },
  watch: {
    route(newRoute, oldRoute) {
      document.title = this.$route.name + " - JNS ";
      this.$store.commit("SET_PAGENAME", newRoute);
      this.$forceUpdate();
    },

    showDrawer: function (value) {
      this.mini = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.box-menu {
  display: flex;
  width: 100%;
  height: 64px;
  align-items: center;
  justify-content: center;

  .box-menu-items {
    display: flex;
    width: 70%;
    align-items: center;
    margin-right: 5px;

    .v-toolbar__title {
      margin: 0 !important;
    }
  }

  .box-menu-perfil {
    display: flex;
    width: calc(30% - 24px);
    align-items: center;
    justify-content: space-around;

    .perfil,
    .button-logout {
      margin-top: 17px;
    }

    .perfil {
      width: 85%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: justify;

      span,
      small {
        color: #fff;
        font-weight: bolder;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      small {
        color: #ccc;
      }
    }
    .button-logout {
      width: 10%;
      margin: 0 0 0 8%;
    }
  }

  @media screen and (max-width: 965px) {
    .box-menu-items {
      width: 89%;
      align-items: center;
      margin-right: 1%;
    }

    .box-menu-perfil {
      width: 10%;
      justify-content: start;

      .perfil {
        display: none;
      }

      .button-logout {
        width: 10%;
      }
    }
  }
}

.menu-font-item {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  box-sizing: border-box;
  color: #fff;
  text-decoration: none;
  height: 64px;
  width: 100px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.1s all;
  border-bottom: 2px solid transparent;
}

.menu-font-item:hover {
  border-bottom: 3px solid rgb(250, 153, 43);
}

.select {
  border-bottom: 3px solid rgb(250, 153, 43);
}
</style>


// WEBPACK FOOTER //
// src/components/JNSMenu.vue